<!-- svelte-ignore a11y-missing-attribute -->
<article class="message is-info">
  <div class="message-body">
    {#if resendError}
      <p class="block">We're having problems sending you an email.</p>
      <p class="block">
        Please retry later. If you're still having problems, let us know at <a
          href="mailto:support@agoodthing.org.uk">support@agoodthing.org.uk</a
        >.
      </p>
    {:else if resent}
      <p class="block">
        We've resent the email. Don't forget to check your junk folder.
      </p>
      <p class="block">
        If you're still having problems, let us know at <a
          href="mailto:support@agoodthing.org.uk">support@agoodthing.org.uk</a
        >.
      </p>
    {:else}
      <p class="block">
        We've sent an email to
        {email}
        to verify your email address.
      </p>
      <p class="block">
        If you haven't received, please check your junk folder or <a
          on:click={resend}>resend the email</a
        >.
      </p>
    {/if}
    <p class="block">
      You will not be able to request offers until your account is verified.
    </p>
  </div>
</article>

<script lang="ts">
  import { appState } from "../../../lib/appState.js";

  import { onDestroy } from "svelte";

  let firebase = window.firebase;

  $: email = $appState.auth_user?.email;

  let resent = false;

  let resendError = false;

  let intervalCookie = setInterval(async () => {
    console.log("reloading");
    await firebase.auth().currentUser!.reload();

    if (firebase.auth().currentUser!.emailVerified) {
      console.log("verified");
      clearInterval(intervalCookie);
      $appState.auth_user = firebase.auth().currentUser;
    }
  }, 10000);

  function resend() {
    firebase
      .auth()
      .currentUser!.sendEmailVerification({
        url: `${$appState.origin}/`,
      })
      .then(() => {
        resent = true;
      })
      .catch((err) => {
        console.log(err);
        resendError = true;
      });
  }

  onDestroy(() => {
    clearInterval(intervalCookie);
  });
</script>
